import React from "react";
import styled from "styled-components";
import {subduedTextColour} from "../../../style/styleConsts";

const Container = styled.div`
    display: flex;
    flex-direction: row;
`;

const Label = styled.div`
    font-size: 12px;
    flex-shrink: 0;
    width: 185px;
    color: ${subduedTextColour};
`;

const SimpleValue = styled.div`
    font-size: 12px;
    color: ${subduedTextColour};
`;

const Value = styled(SimpleValue)`
    font-weight: bold;
`;


export const requirementRow = (className, name, value) => {
    return <Container key={className}>
        <Label className={className  + "-label"}>{name}</Label>
        <Value className={className}>{value}</Value>
    </Container>;
};

export const conditionalRequirementRow = (className, name, value) => {
    return <Container key={className}>
        <Label className={className  + "-label"}>{name}</Label>
        <SimpleValue className={className}>{value}</SimpleValue>
    </Container>;
};

export const stockRestrictionTreeRow = (className, name, value) => {
    return <Container key={className}>
        <Label className={className  + "-label"}>{name}</Label>
        <SimpleValue className={className}>{value}</SimpleValue>
    </Container>;
};